// @ts-nocheck
import React, { useState } from 'react';
import { Modal, Box, Button, Typography, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import SendIcon from '@mui/icons-material/Send';

const Root = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    boxShadow: 24,
    padding: '25px',
    width: 400,
    [theme.breakpoints.down('sm')]: {
        width: '80%',
    },
}));

export default function Enviar({ enviar, loading, tipoEnvio }) {
    const [open, setOpen] = useState(false);
    const isMobile = useMediaQuery('(max-width:600px)');

    const handleConfirm = () => {
        setOpen(false);
        enviar();
    };

    return (
        <>
            <Button
                sx={{ textTransform: 'none' }}
                variant="contained"
                color="primary"
                onClick={() => setOpen(true)}
                disabled={loading}
            >
                {loading && tipoEnvio === 'enviar' ? "Enviando..." : "Enviar"}
            </Button>

            <Modal open={open} onClose={() => setOpen(false)}>
                <Root>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <SendIcon color="primary" />
                            <Typography variant="h6">Confirmar Envío</Typography>
                        </Box>

                        <Typography variant="body1" color="text.secondary">
                            La difusión será enviada <strong>en este momento</strong>
                        </Typography>

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                            <Button sx={{ textTransform: 'none' }} variant="outlined" onClick={() => setOpen(false)}>Cancelar</Button>
                            <Button sx={{ textTransform: 'none' }} variant="contained" color="primary" onClick={handleConfirm}>
                                Confirmar
                            </Button>
                        </Box>
                    </Box>
                </Root>
            </Modal>
        </>
    );
}
